"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPreferences = void 0;
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
class UserPreferences {
    constructor(o = {}) {
        this.favouriteLmssIds = [];
        this.notificationDailyDigest = false;
        this.notificationWeeklyDigest = false;
        this.notifyByEmail = false;
        this.notifyByPush = true;
        this.language = Language_1.default.ENGLISH;
        Object.assign(this, o);
    }
    isFavourite(favId) {
        return this.favouriteLmssIds.indexOf(favId) >= 0;
    }
    setFavourite(favId, onoff) {
        this.favouriteLmssIds = this.favouriteLmssIds.filter(id => id !== favId);
        if (onoff)
            this.favouriteLmssIds.push(favId);
    }
}
exports.UserPreferences = UserPreferences;
exports.default = UserPreferences;
